import Leaf from "../Components/Leaf/Leaf";

const LeafPage = () => {
    return (
        <Leaf />
    )
}
export default LeafPage;